module.exports = __webpack_public_path__ + "static/media/L.e592b057.jpg";